import { FastlyImage } from '@components/common/image'

type Props = {
  title: string
  subHeading: string
}

const FirstFold = ({ title, subHeading }: Props) => (
  <div
    className="text-white"
    style={{
      background:
        'linear-gradient(287.41deg, #BF3240 -8.7%, #B73252 24.1%, #7E36D9 100%),linear-gradient(0deg, #FF5A43, #FF5A43',
    }}
  >
    <div className="container lg:flex justify-center mx-auto px-2 lg:px-5">
      <div className="flex flex-col justify-center text-center lg:text-left">
        <h1 className="font-700 text-5xl pt-10 lg:pt-0 pb-4 leading-10">
          {title}
        </h1>
        <h2 className="text-2xl pb-20 lg:pb-0 leading-7 w-full lg:w-10/12">
          {subHeading}
        </h2>
      </div>
      <div className="hidden lg:block -mb-2">
        <FastlyImage
          src="/images/prepare-for-competitions/masterclasses/poster.png"
          alt="poster image"
          height={464}
          width={744}
        />
      </div>
    </div>
  </div>
)

export default FirstFold
